/* eslint-disable camelcase */

import { CONFIG } from "~/config";

const UTM_WEB = {
	utm_source: "mapy_web",
	utm_medium: "store_button",
	utm_campaign: "promo_button_appinstall",
};
const UTM_RESPONSIVE_WEB = {
	utm_source: "mapy_mobilni_web",
	utm_medium: "banner_responziv",
	utm_campaign: "responziv_appinstall",
};

// Preklady tady natvrdo, protoze marketing chce mit k jazykum ruzny text
export const LOCALE_STRINGS = {
	cs: {
		title: "Psst.. co takhle lepší Mapy.cz?",
		desc: "S hledáním a plánováním bez internetu a taky s navigací v reálném provozu.",
		downloadBtn: "Stáhnout Mapy.cz",
		notNowBtn: "Teď ne",
	},
	sk: {
		title: "Psst.. čo takto lepšie Mapy.com?",
		desc: "S vyhľadávaním a plánovaním bez internetu a tiež s navigáciou v reálnej premávke.",
		downloadBtn: "Stiahnuť Mapy.com",
		notNowBtn: "Teraz nie",
	},
	pl: {
		title: "A może mobilna aplikacja?",
		desc: "Wyszukuj i planuj trasy nawet bez internetu. Teraz całkowicie po polsku.",
		downloadBtn: "Pobierz za darmo",
		notNowBtn: "Nie teraz",
	},
	de: {
		title: "Wie wäre es mit einer mobilen App?",
		desc: "Suche und plane Routen auch ohne Internet. Jetzt komplett auf Deutsch.",
		downloadBtn: "App Herunterladen",
		notNowBtn: "Jetzt nicht",
	},
	uk: {
		title: "Як щодо мобільного додатку?",
		desc: "Шукайте та плануйте маршрути навіть без інтернету. Тепер повністю українською.",
		downloadBtn: "Завантажити безкоштовно",
		notNowBtn: "Зараз ні",
	},
	ru: {
		title: "Как насчёт мобильного приложения?",
		desc: "Ищите и планируйте маршруты даже без интернета. Теперь полностью по-русски.",
		downloadBtn: "Скачать бесплатно",
		notNowBtn: "Сейчас нет",
	},
	it: {
		title: "Che ne dici di un'app mobile?",
		desc: "Cerca e pianifica percorsi anche senza internet. Ora completamente in italiano.",
		downloadBtn: "Scarica gratis",
		notNowBtn: "Non ora",
	},
	fr: {
		title: "Et si vous essayiez une application mobile?",
		desc: "Recherchez et planifiez sans internet. Maintenant en français.",
		downloadBtn: "Télécharger gratuitement",
		notNowBtn: "Pas maintenant",
	},
	nl: {
		title: "Wat dacht je van een mobiele app?",
		desc: "Zoek en plan routes, zelfs zonder internet. Nu volledig in het Nederlands.",
		downloadBtn: "Gratis downloaden",
		notNowBtn: "Nu niet",
	},
	es: {
		title: "Qué tal una aplicación móvil?",
		desc: "Busca y planifica rutas incluso sin internet. Ahora completamente en español.",
		downloadBtn: "Descargar gratis",
		notNowBtn: "Ahora no",
	},
	en: {
		title: "How about a mobile app?",
		desc: "With route search and planning, even offline and free turn-by-turn navigation.",
		downloadBtn: "Download Mapy.com",
		notNowBtn: "Not now",
	},
};
const SUPPORTED_LANGUAGES = Object.keys(LOCALE_STRINGS);
const LANGUAGE_VARIABLES: {
	[K in typeof SUPPORTED_LANGUAGES[number]]: string;
} = {
	cs: "cz",
	sk: "sk",
	pl: "pl",
	de: "de",
	uk: "cz",
	ru: "cz",
	it: "it",
	fr: "cz",
	nl: "cz",
	es: "cz",
	en: "cz",
};

export function getMobilePromoLink(sourceLink: string, isResponsive?: boolean) {
	const utmSource = isResponsive
		? UTM_RESPONSIVE_WEB
		: UTM_WEB;
	const outputLink = new URL(sourceLink);

	Object.keys(utmSource).forEach(key => {
		outputLink.searchParams.append(key, utmSource[key]);
	});

	return outputLink.toString();
}

export function getMobilePromoLink2(system: "a" | "i") {
	const language = SUPPORTED_LANGUAGES.indexOf(CONFIG.defaultLang as unknown as typeof SUPPORTED_LANGUAGES[number]) === -1 ? "en" : CONFIG.defaultLang as unknown as typeof SUPPORTED_LANGUAGES[number];
	const variables = LANGUAGE_VARIABLES[language];

	return system === "a"
		? `https://play.google.com/store/apps/details?id=cz.seznam.mapy&hl=${language}&utm_source=mapy_mobilni-web&utm_medium=banner_resp&utm_campaign=mapy-app-promo-internal&utm_content=${language}-lang&referrer=banner_resp`
		: `https://apps.apple.com/${variables}/app/id411411020?l=${language}&pt=282263&ct=mapy-app-promo_banner_resp&mt=8`;
}
